import { render, staticRenderFns } from "./CustomOptionsList.vue?vue&type=template&id=68f36369&"
import script from "./CustomOptionsList.vue?vue&type=script&lang=js&"
export * from "./CustomOptionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports